import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Button } from '../../../../shadcn/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '../../../../shadcn/components/ui/dialog'
import { Icon, Spinner } from '../../../atoms'

export type ProposalAdvisorConversationDeleteMessageConfirmationState =
  | 'ready'
  | 'deleting'

export type ProposalAdvisorConversationDeleteMessageConfirmationProps =
  Readonly<{
    quit: () => void
    confirm: () => void
    state: ProposalAdvisorConversationDeleteMessageConfirmationState
  }>

export function ProposalAdvisorConversationDeleteMessageConfirmation({
  confirm,
  quit,
  state,
}: ProposalAdvisorConversationDeleteMessageConfirmationProps) {
  return (
    <Dialog defaultOpen onOpenChange={(isOpen) => !isOpen && quit?.()}>
      <DialogContent
        backdropStyle='dark'
        className='flex flex-col p-0 md:h-[278px] md:w-[600px]'
      >
        <header className='flex flex-row items-center p-5'>
          <DialogTitle>
            <FormattedMessage
              id='ui.ProposalAdvisorConversationDeleteMessageConfirmation.title'
              defaultMessage='Supprimer le message'
            />
          </DialogTitle>
          <Icon
            className='ml-auto h-3 w-3'
            name='cross-without-circle'
            color='black'
            style={{ cursor: 'pointer' }}
            onClick={() => quit()}
          />
        </header>
        <p className='p-5'>
          <FormattedMessage
            id='ui.ProposalAdvisorConverfsationDeleteMessageConfirmation.areYouSure'
            defaultMessage='Êtes-vous sûr de vouloir supprimer le message ?'
          />
        </p>
        <hr className='mt-auto border-border' />
        <div className='flex flex-row gap-4 p-5'>
          <Button variant='outline' onClick={() => quit()}>
            <FormattedMessage
              id='ui.ProposalAdvisorConversationDeleteMessageConfirmation.cancel'
              defaultMessage='Annuler'
            />
          </Button>
          <Button
            variant='destructive'
            onClick={() => confirm()}
            disabled={state === 'deleting'}
          >
            {state === 'ready' ? (
              <FormattedMessage
                id='ui.ProposalAdvisorConversationDeleteMessageConfirmation.confirm'
                defaultMessage='Supprimer le message'
              />
            ) : (
              <Spinner width={25} height={25} color='grey' />
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
